<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de tipos de espécies</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Tipos de espécie</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0 text-left">Espécie</th>
                    <th scope="col" class="border-0 text-left">Gateway</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(specieType, index) in specieTypes" :key="index">
                    <td></td>
                    <td>
                      {{
                        specieType.Code == undefined ||
                        specieType.Code == "" ||
                        specieType.Code == null
                          ? "-"
                          : specieType.Code
                      }}
                    </td>
                    <td class="text-left">{{ specieType.Name }}</td>
                    <td class="text-left">{{ specieType.Gateway.Name }}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('SpecieType', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenSpecieType($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('SpecieType', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenSpecieType($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      specieTypes == undefined ||
                      specieTypes == null ||
                      specieTypes.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      id="mFormSpecieType"
      :title="modalTitle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="validatedSpecieTypeForm">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Código</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoSpecieType.Code"
                  :class="validatedSpecieTypeForm | showValidateError(invalid)"
                  :disabled="isSeeing || pOpened != null"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedSpecieTypeForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoSpecieType.Name"
                  :class="validatedSpecieTypeForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedSpecieTypeForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedSpecieTypeForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  :value="null"
                  v-model="infoSpecieType.Gateway.Code"
                >
                  <option :value="null" selected>Selecione o Gateway</option>
                  <option
                    v-for="type in gateways"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedSpecieTypeForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveSpecieType()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select :value="null" v-model="filter.Gateway.Code">
            <option :value="null" selected>Selecione o Gateway</option>
            <option
              v-for="type in gateways"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('SpecieType', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo tipo de espécie"
      v-on:click="OpenSpecieType($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "specie-types",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Novo tipo de espécie",
      countFilter: 0,
      filter: {
        Name: null,
        Gateway: {
          Code: null,
        },
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      IdSpecieType: 0,
      pOpened: null,
      specieTypes: [],
      specieTypefilter: [],
      gateways: [],
      infoSpecieType: {
        Name: null,
        Code: null,
        Gateway: {
          Code: null,
        },
      },
      isSeeing: false,
      validatedSpecieTypeForm: false,
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListSpecieType();
    },
    "pagination.RowsPerPage": function () {
      this.ListSpecieType();
    },
  },
  mounted() {
    this.ListSpecieType();
    this.ListGateways();
  },
  methods: {
    OpenSpecieType: function (e, i, view) {
      e.preventDefault();
      this.validatedSpecieTypeform = false;
      this.ResetInfoSpecieType();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idSpecieType = this.specieTypes[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar espécie";
        this.GetSpecieType();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoSpecieType;
        this.isSeeing = false;
        this.modalTitle = "Novo tipo de espécie";
        this.ResetInfoSpecieType();
      } else {
        // View
        this.pOpened = i;
        this.idSpecieType = this.specieTypes[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da espécie";
        this.GetSpecieType();
      }
      this.$bvModal.show("mFormSpecieType");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListSpecieType();
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        idSpecieType: null,
        Gateway: {
          Code: null,
        },
      };
      this.ListSpecieType();
    },
    ResetInfoSpecieType: function () {
      this.infoSpecieType = {
        Name: null,
        Code: null,
        Gateway: {
          Code: null,
        },
      };
    },
    SaveSpecieType: function () {
      this.validatedSpecieTypeForm = true;

      this.$refs.validatedSpecieTypeForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddSpecieType", this.infoSpecieType)
              .then(() => {
                this.$makeToast(
                  "A Espécie foi cadastrada com sucesso.",
                  "success",
                  "Espécie cadastrada"
                );
                this.ListSpecieType();
                this.$bvModal.hide("mFormSpecieType");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao cadastrar a Espécie",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateSpecieType", this.infoSpecieType)
              .then(() => {
                this.$makeToast(
                  "A Espécie foi atualizada com sucesso.",
                  "success",
                  "Espécie atualizada"
                );
                this.ListSpecieType();
                this.$bvModal.hide("mFormSpecieType");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a Espécie.",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetSpecieType: function () {
      if (this.idSpecieType != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetSpecieType", { id: this.idSpecieType })
          .then((response) => {
            this.infoSpecieType = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar a Espécie",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListSpecieType: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Gateway.Code)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Gateway.Code": this.filter.Gateway.Code,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListSpecieType", { params: data })
        .then((response) => {
          this.specieTypes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as Espécies",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListGateways() {
      this.$store
        .dispatch("ListGateway")
        .then((response) => {
          this.gateways = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente...",
            "danger",
            "Erro ao obter a lista de gateways",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/specieTypes.vue